export const PROMOS_REQUEST_ERROR = 'Не удалось загрузить акции и скидки! Пожалуйста, попробуйте еще раз.';
